module.exports = __webpack_public_path__ + "img/coupon_tutorial_totolu02.b34752cf.png";